import { useEffect, useMemo, useState } from 'react';
import axios from 'common/requester';
import { LINB_API } from 'common/constants/api-urls';
import _ from 'lodash';

const usePdtEntities = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [entities, setEntities] = useState([]);

  const entitiesByIds = useMemo(() => _.keyBy(entities, 'id'), [entities]);

  const getEntityById = id => entitiesByIds[id];

  const fetchPdtEntities = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        LINB_API.PM_SERVICE.PM_ENTITIES.PDT_PROJECT_FILTERS
      );
      setEntities(res);
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPdtEntities();
  }, []);

  return {
    entities,
    getEntityById,
    isLoading
  };
};

export default usePdtEntities;
